import type {
  LocationBootstrapMeter,
  LocationBootstrapPayload,
} from '@/features/location-bootstrap/location-bootstrap-types';
import { CACHED_METER_STATUSES } from '@/shared/meter-identification';

export function toMeterSearchData(payload: LocationBootstrapPayload, meter: LocationBootstrapMeter) {
  return {
    _id: meter._id,
    accessibility: meter.accessibility,
    apiKey: meter.apiKey,
    buildingId: meter.buildingId,
    buildingName: meter.buildingName,
    calibrated: meter.calibrated,
    combinedMeterId: meter._id,
    detail: meter.detail,
    devEui: meter.devEui,
    floorName: meter.floorName,
    floorplanLat: meter.floorplanLat,
    floorplanLng: meter.floorplanLng,
    gpsLat: meter.gpsLat,
    gpsLng: meter.gpsLng,
    id: meter.id,
    imsi: meter.imsi,
    internalNote: meter.internalNote,
    internalSupplyPointCode: meter.internalSupplyPointCode,
    locationId: payload.locationId,
    lorawanRssi: meter.lorawanRssi,
    manufactured: meter.manufactured,
    manufacturerId: meter.manufacturerId,
    commodity: meter.commodity,
    meterModelId: meter.meterModelId,
    mountTechnology: meter.mountTechnology,
    mountType: meter.mountType,
    name: meter.name,
    nbiotRssi: meter.nbiotRssi,
    ownerName: meter.ownerName,
    ownerType: meter.ownerType,
    placement: meter.placement,
    raw: meter.raw,
    registers: meter.registers,
    remoteReadingOwner: meter.remoteReadingOwner,
    remoteReadingSerial: meter.remoteReadingSerial,
    requiresManualAks: meter.requiresManualAks,
    serial: meter.serial,
    status: meter.status ?? CACHED_METER_STATUSES.downloaded,
    submittedBy: meter.submittedBy,
    tenant: meter.tenant,
    toolsId: meter.toolsId,
    updatedAt: meter.updatedAt,
  };
}

export function cacheId(locationId: number | string, kind: string, entityId: number | string) {
  return `location:${locationId}:${kind}:${entityId}`;
}
